import yaml from "yaml";
import LambdaLib from "@jurinfor/game-process/lambda";
import { BooleanId, StringId, NumberId, ObjectId, SingletonId, UntypedArrayId, TypedArrayId, FormatTypeId, OptionalId, UnionId } from "@jurinfor/typing";
import { config as configProcess, getFormReaction } from "@jurinfor/game-process";
import { CreateExcel } from "@jurinfor/js-excel";
import pickRandomOption from "./bots/pickRandomOption";
import OrderFormProcess from "./ext-function/OrderFormProcess";
import ApplicationFormProcess from "./ext-function/ApplicationFormProcess";
import { mergeFragments, TableFragment, CellMarkdown, Sheet, Spreadsheet } from "./ext-function/excel-model";
import exportCell from "./ext-function/exportCell";
import makeReport from "./ext-function/makeReport";

import { colTypeNames, colTypeToString } from "./models/colTypeNames";
import tableTransformation from "./ext-function/tableTransformation";
import generateContextBySignature from "./ext-function/generateContextBySignature";
import { extractTableDataForContext, extractTableDataForContexts } from "./ext-function/extractTableDataForContext";
import { transpose, uniq, groups } from "./ext-function/tablefn";

const { config, importFromJSON, exportToJSON, reduce } = LambdaLib;
const { isLambdaJSON, StringToLambdaJSON, LambdaJSONToString } = LambdaLib.json;
const { reduceLambdaObject } = LambdaLib.lambdaObject;

Object.assign(config.FUNCTION_EXEC_CONTEXT, {
  ...{ BooleanId, StringId, NumberId, ObjectId, SingletonId, UntypedArrayId, TypedArrayId, FormatTypeId, OptionalId, UnionId },
  parseYAML: yaml.parse,
  stringifyYAML: yaml.stringify,
  colTypeNames,
  colTypeToString,
  tableTransformation,
  generateContextBySignature,
  extractTableDataForContext,
  extractTableDataForContexts,
  transpose,
  uniq,
  groups,
  ...{ mergeFragments, TableFragment, CellMarkdown, Sheet, Spreadsheet },
  exportCell,
  makeReport,
  CreateExcel,
  OrderFormProcess,
  ApplicationFormProcess,
  getFormReaction,
  pickRandomOption,
  isLambdaJSON,
  importFromJSON,
  exportToJSON,
  StringToLambdaJSON,
  LambdaJSONToString,
  LambdaLib,
  reduce,
  reduceLambdaObject(obj) {
    const rl = configProcess.lambda.reduction;
    const result = reduceLambdaObject(obj, rl);
    if (!result) throw new Error('Could not reduce');
    return result;
  },
});

window.CONTEXT = config.FUNCTION_EXEC_CONTEXT;

export default config;

